import { compose, withProps } from 'recompose';
import { get } from 'lodash';
import { withRouter } from 'react-router';

export default compose(
  withRouter,
  withProps(props => ({
    bookNoPayQuery: get(props, 'location.query.bookNoPay', false),
  }))
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithBookNoPayQuery.js